import axios from 'axios';
import queryString from 'query-string';

import { env } from 'env';
import { SELECTED_ENTITY, USER_ID } from 'types';

// Please have a look at here `https://github.com/axios/axios#request-config` for the full list of configs
const { CancelToken } = axios;
export const sourceCancel = CancelToken.source();

const baseURLBlog = `${env.service.blogService}/api/v1`;

// entity service
const blogService = axios.create({
  baseURL: baseURLBlog,
  cancelToken: sourceCancel.token,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json',
  },
  paramsSerializer: params => queryString.stringify(params),
});

blogService.interceptors.response.use(
  response => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  error => {
    if (
      error.response.data?.message === 'Invalid access domain' &&
      error.response.status === 403
    ) {
      localStorage.removeItem(USER_ID);
      localStorage.removeItem(SELECTED_ENTITY);
      updateTokenBearer('');
      window.location.replace('/admin');
    }
    throw error;
  }
);

export const getTokenBearer = () =>
  blogService.defaults.headers.common.Authorization;

export const updateTokenBearer = token => {
  blogService.defaults.headers.common.Authorization = token;
};

export const updateTokenID = token => {
  blogService.defaults.headers.common['token-id'] = token;
};

export const updateCurrentEntityBlog = (entityID, type) => {
  blogService.defaults.headers.common['entity-id'] = entityID;
  blogService.defaults.headers.common.type = type;
};

export const removeCurrentEntityBlog = () => {
  delete blogService.defaults.headers.common['entity-id'];
  delete blogService.defaults.headers.common.type;
};

export const updateUserAgent = (content: string): void => {
  blogService.defaults.headers.common['user-agent-hub'] = content;
};

export const removeUserAgent = (): void => {
  const value = blogService.defaults.headers.common['user-agent-hub'];
  delete blogService.defaults.headers.common['user-agent-hub'];
  return value;
};

export const updateBaseURL = (url: string): void => {
  blogService.defaults.baseURL = url;
};

export default blogService;
